import React from 'react';
import { useNotice } from '../../contexts/NoticeContext';
import NoticeBar from './NoticeBar';

interface NoticeContainerProps {
  pageKey?: string;
  className?: string;
}

const NoticeContainer: React.FC<NoticeContainerProps> = ({ pageKey, className = '' }) => {
  const { getNoticesForPage, removeNotice } = useNotice();
  const notices = getNoticesForPage(pageKey);

  if (notices.length === 0) {
    return null;
  }

  return (
    <div className={`space-y-4 ${className}`}>
      {notices.map((notice) => (
        <NoticeBar
          key={notice.id}
          notice={notice}
          onDismiss={removeNotice}
        />
      ))}
    </div>
  );
};

export default NoticeContainer;